module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.12@core-js/modules/_library.js
// module id = BKPO
// module chunks = 16